(() => {
 const initialise = () => {
  const form = document.getElementById('RenAirPurchase');
  if (!form || form.dataset.initialised) return;
  form.dataset.initialised = 'true';
  const quantity = form.querySelector('[name="quantity"]');
  const total = form.querySelector('[data-product-total]');
  if (!quantity || !total) return;
  const update = () => {
    const plan = form.querySelector('[name="selling_plan"]:checked');
    const amount = Number(plan?.dataset.price);
    const count = Number(quantity.value);
    if (!plan || !quantity.checkValidity() || !Number.isFinite(amount) || !Number.isInteger(count)) {
      total.textContent = ''; return;
    }
    total.textContent = new Intl.NumberFormat(total.dataset.locale || 'en-AU', {
      style: 'currency', currency: total.dataset.currency || 'AUD'
    }).format(amount * count / 100);
  };
  form.addEventListener('change', update);
  quantity.addEventListener('input', update);
  update();
 };
 initialise();
 document.addEventListener('renair:product-ready', initialise);
})();
